// extracted by mini-css-extract-plugin
export default {"CustomCheckbox":"CustomCheckbox_CustomCheckbox__YrbYe"};